// extracted by mini-css-extract-plugin
module.exports = {"root":"ChipSwitch_root__MSfi1","label":"ChipSwitch_label__yWGYq","active":"ChipSwitch_active__96D5L"};